export default __webpack_public_path__ + "static/media/2.9e227f46.png";